import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { generatePkceParams, savePkce } from "../api/pkce";
import { discoverOidc } from "../api/oidc";

const AUTH_URL = import.meta.env.VITE_AUTH_URL ?? "https://auth.example.com";
const CLIENT_ID = import.meta.env.VITE_AUTH_CLIENT_ID ?? "lplanner";
const REDIRECT_URI =
  import.meta.env.VITE_REDIRECT_URI ?? `${window.location.origin}/callback`;

interface LocationState {
  from?: { pathname?: string };
}

function authHost(): string {
  try {
    return new URL(AUTH_URL).host;
  } catch {
    return AUTH_URL;
  }
}

export function LoginPage() {
  const location = useLocation();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const state = location.state as LocationState | null;
        const returnTo = state?.from?.pathname ?? "/";

        const params = await generatePkceParams();
        savePkce(params, returnTo);

        const qs = new URLSearchParams({
          response_type: "code",
          client_id: CLIENT_ID,
          redirect_uri: REDIRECT_URI,
          scope: "openid profile email offline_access",
          state: params.state,
          nonce: params.nonce,
          code_challenge: params.codeChallenge,
          code_challenge_method: "S256",
        });
        const provider = await discoverOidc();
        if (cancelled) return;
        window.location.replace(`${provider.authorization_endpoint}?${qs.toString()}`);
      } catch (e) {
        if (cancelled) return;
        setError(e instanceof Error ? e.message : "Не удалось запустить вход");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.state]);

  return (
    <div className="auth-splash">
      <div className="auth-splash-card">
        <div className="auth-splash-brand">L</div>
        <div className="auth-splash-title">
          {error ? "Не удалось войти" : `Перенаправляем на ${authHost()}…`}
        </div>
        <div className="auth-splash-sub">
          {error ? (
            <>
              {error}
              <br />
              <a href="/login">Попробовать ещё раз</a>
            </>
          ) : (
            <>Если ничего не происходит — обновите страницу.</>
          )}
        </div>
      </div>
    </div>
  );
}
